module.exports = __webpack_public_path__ + "static/media/home_gateway.96d5a082.png";